import { useFunnelStore } from '@/store/useFunnelStore';

/**
 * Says out loud that edits have stopped reaching the shared scenario.
 *
 * The load path refuses outright when the service is unreachable, so this only
 * appears when a session opened successfully and the service went away
 * afterward. The canvas keeps working from localStorage — interrupting someone
 * mid-sentence would be worse — but silently not saving is precisely the failure
 * that must never be invisible.
 */
export function DegradedBanner() {
  const degraded = useFunnelStore((s) => s.degraded);
  if (!degraded) return null;

  return (
    <div className="degraded-banner" role="status">
      <strong>Changes aren’t being saved.</strong> The scenario service stopped
      responding, so edits are being kept in this browser only. Reload once it is
      back to sync them.
    </div>
  );
}
